import { gql } from "@apollo/client"

export const CURRENT_PERSON_BANDS_QUERY = gql`
  query TerminatedModalMembershipBands {
    currentPerson {
      id
      bands {
        id
        createdReason
      }
    }
  }
`
